import React from 'react';
import { DialogModal } from '@/components/DialogModal';
import { DestructiveActionDialog } from '@/components/DestructiveActionDialog';

export function PolicyApplicationDeleteModal({
  open,
  onClose,
  onConfirm,
  productName,
  clientName,
  applicationStatus,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  productName: string;
  clientName: string;
  applicationStatus: ApplicationStatus;
}) {
  if (applicationStatus === 'completed') {
    return (
      <DialogModal
        open={open}
        onClose={onClose}
        title="Deletion Not Permitted"
        width="md"
        subTitle=""
      >
        <p className="mt-4 text-gray-500">
          Because {clientName} has submitted the insurance application, their data is subject to a
          7-year regulatory retention period and cannot be deleted.
          <br />
          <br />
          You can either archive the client or delete the client under a privacy law like CCPA.
        </p>
      </DialogModal>
    );
  }

  return (
    <DestructiveActionDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Clear Progress?"
      description={
        <>
          Are you sure you want to clear the progress for this unsubmitted {productName}{' '}
          application?
          <br />
          <br />
          Any consent provided during this application process will be retained. This action cannot
          be undone.
        </>
      }
      confirmButtonText="Clear"
    />
  );
}
